import { Card, Image, Marquee, Text } from '@chakra-ui/react';
import { allCommodities, Commodity } from 'helpers/fakeData';
import Link from 'next/link';

interface CommodityTickerSummaryProps {
  commodity: Commodity;
  commodityHref: (id: string) => string;
}

const BOX_SIZE = '20px';
const CommodityTickerSummary = ({ commodity, commodityHref }: CommodityTickerSummaryProps) => {
  const { name, ticker, price, image, id } = commodity;
  return (
    <Link href={commodityHref(id)}>
      <Card.Root
        bg="surface.muted"
        borderRadius="xl"
        p={2}
        cursor="pointer"
        _hover={{ borderColor: 'border.dark' }}
      >
        <Card.Body flexDirection="row" alignItems="center" gap={2} p={0}>
          <Image src={image} boxSize={BOX_SIZE} borderRadius="full" fit="cover" alt={name} />
          <Text fontSize="xs" fontWeight="bold" color="text.primary">
            {ticker}
          </Text>
          <Text fontSize="xs" fontWeight="medium" color="text.primary">
            GHS{price}
          </Text>
        </Card.Body>
      </Card.Root>
    </Link>
  );
};

interface Props {
  commodityHref: (id: string) => string;
}
const CommodityMarquee = ({ commodityHref }: Props) => {
  return (
    <Marquee.Root pauseOnInteraction speed={100} flexShrink={0}>
      <Marquee.Viewport>
        <Marquee.Content>
          {allCommodities.map((item, i) => (
            <Marquee.Item key={i}>
              <CommodityTickerSummary commodity={item} commodityHref={commodityHref} />
            </Marquee.Item>
          ))}
        </Marquee.Content>
      </Marquee.Viewport>
    </Marquee.Root>
  );
};

export default CommodityMarquee;
